import styled from "styled-components";

export const MemberContainer = styled.div`
  margin: 7rem 15vh;
  padding-bottom: 5rem;
  @media screen and (max-width: 900px ){
    margin: 0 1.8rem;
  }
  @media screen and (max-width: 500px ){
    margin: 0 1.3rem;
  }

`